import { atom } from 'jotai'
import { FileId } from 'sierra-domain/flexible-content/identifiers'

export const reviewSuggestionsAtom = atom<{ [fileId: FileId]: boolean }>({})
